import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import * as _set from 'lodash/set';
import * as _cloneDeep from 'lodash/cloneDeep';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import {user} from '../../../../store/reducers/user';
import {CoreDataTextField} from '../../../../components/core/textFieldWithCoreData';
import {ChiefOfComplaint} from '../../../../controls/agyle/ecds';
import Formatter from '../../../../util/formatter';
import {SmokingForm} from '../../inpatientForms/smokingForm';
import {AuditCForm, buildAuditCListModification, getLatestAuditCEntry} from '../../inpatientForms/auditCForm';
import uuidv4 from 'uuid/v4';
import config from '../../../../app/config';
import AgyleButton from '../../../../components/ui/buttons/agyleButton';
import AgyleTextField from '../../../../components/ui/fields/agyleTextField';
import AgyleBlockSwitch from '../../../../components/ui/switch/agyleBlockSwitch';
import Notes from '../../../../util/notes';
import AgyleAccordion from '../../../../components/ui/accordion/agyleAccordion';
import MultipleEntriesFormList from '../../../../components/forms/multipleEntriesFormList';
import Delirium from '../delirium/delirium';
import InformationBox from '../../../../components/other/informationBox';
import AgyleStepper from '../../inpatientForms/AgyleStepper';
import {formAuditIsValid, formSmokeIsValid} from '../formsUtil';
import {openPatientForm} from '../../../../store/reducers/patientContext';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    textField: {
        width: '100%',
    },
    modal: {
        top: '20px',
        position: 'absolute',
        background: '#535252',
        width: '86%',
        zIndex: 99,
        height: 'calc(100% - 40px)',
        overflow: 'auto',
        padding: '20px',
        marginLeft: '5.5%',
    },
    modalSmall: {
        top: '20%',
        width: '50%',
        height: '150px',
        padding: '20px',
        zIndex: 99,
        overflow: 'auto',
        position: 'absolute',
        background: '#535252',
        marginLeft: '25%',
        textAlign: 'center',
    },
    topBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingBottom: 15,
        position: 'sticky',
        top: '0px',
        background: theme.palette.background.defaultBackground,
        zIndex: 11,
    },
    flexDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    formName: {
        fontSize: 16,
        fontWeight: 600,
    },
    modalTitle: {
        textAlign: 'center',
        fontSize: 20,
        fontWeight: 'bold',
    },
    backgroundModal: {
        position: 'absolute',
        background: 'black',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: '0.7',
        zIndex: 99,
    },
    selectorItemFormControl: {
        width: '100%',
        marginBottom: 5,
    },
    selectorItemSelect: {
        width: '100%',
        fontSize: '80%',
        marginTop: '9px !important',
    },
    selectorItemLabel: {
        fontSize: '80%',
    },
    button: {
        display: 'inline-flex',
        minWidth: 105,
        marginRight: 10,
    },
    buttonLeft: {
        float: 'left',
        marginTop: 20,
        marginLeft: 20,
    },
    formControl: {
        width: '100%',
        marginBottom: 10,
    },

    vteItem: {
        border: '1px solid black',
        padding: 10,
        background: '#424242',
        borderRadius: '9px',
        marginBottom: '10px',
    },
    outcome: {
        border: '1px solid #7199E6',
        background: '#cfdffd',
        padding: 10,
        color: '#3F73D6',
        marginTop: 10,
        marginBottom: 10,
    },
    auditImg: {
        width: '100%', maxWidth: 700,
    },
    scores: {
        fontSize: 20, fontWeight: 'bold', textAlign: 'right',
    },
    outcomeLabel: {
        fontWeight: 'bold',
        fontSize: 15,
        color: '#3F73D6',
    },
    modalFooter: {
        height: 50,
        marginTop: 10,
        position: 'relative',
        bottom: 0,
    },
    modalHeader: {
        height: 'max-content',
        position: 'relative',

    },
    formContainer: {
        background: theme.palette.inPatient.formBackground,
        borderRadius: 10,
        padding: 20,
    },
    modalBody: {
        position: 'relative',
        height: 'calc(100% - 170px)',
        overflow: 'auto',
        paddingTop: 20,
    },
    containerGrid: {
        width: 'calc(100% - 10px)',
    },
    header1: {
        fontSize: 30,
        marginTop: 10,
        marginBottom: 10,
        fontWeight: 'bold',
    },
    header2: {
        fontWeight: 'bold',
        marginBottom: 10,
        fontSize: 20,
    },
    info: {
        border: '1px solid #7199E6',
        background: '#fdcfdf',
        padding: 10,
        color: '#d63f3f',
        marginTop: 10,
        marginBottom: 10,
    },
    infoLabel: {
        fontWeight: 'bold',
        fontSize: 15,
        color: '#d63f3f',
    },
    oxygenModal: {
        position: 'absolute',
        background: '#333333',
        padding: 40,
        top: 20,
        left: 0,
        zIndex: 100,
    },
    historyTitle: {
        fontSize: 20,
        fontWeight: 'bold',
        marginBottom: 10,
    },
    updatedLabel: {
        float: 'right',
        paddingRight: 30,
    },
    coreField: {},
    historyItem: {
        marginBottom: 20,
        border: '1px solid #7b7a7a',
        padding: 10,
        borderRadius: 5,
    },
    inputLabel: {
        color: theme.palette.inPatient.questionText,
        fontSize: 12,
        fontWeight: 600,
        marginLeft: 5,
        marginBottom: 5,
    },
    deliriumLabel: {
        fontSize: 16,
        fontWeight: 600,
        marginTop: 20,
        marginBottom: 10,
    },
}));

function getSteps() {
    return ['History', 'Examination', 'Audit C', 'Smoking', 'Plan'];
}

function InlineClerkingForm(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const steps = getSteps();
    let formBase = {
        name: 'Clerking',
        createDate: null,
        statusClosed: false,
        by: '',

        chiefComplaint: '',
        pastMedicalHistory: '',
        medications: '',
        allergies: '',
        socialHistory: '',

        examination: {
            examination: '',
        },
        plan: {
            workingDiagnosis: '',
            managementPlan: '',
            workingDiagnosisNote: '',
            LMWHPrescribed: null,
        },
    };

    const [activeStep, setActiveStep] = React.useState(0);
    const [confirmModalVisible, setConfirmModalVisible] = React.useState(false);

    const [form, setForm] = React.useState(formBase);
    const [formOxygenData, setOxygenFormData] = useState(props.patient?.oxygen);
    const [formSmokingData, setSmokingFormData] = useState(props.patient?.smoking);
    const [formAuditCData, setAuditCFormData] = useState(getLatestAuditCEntry(props.patient));
    const [delirium, setDelirium] = React.useState(null);

    const [auditIsValid, setAuditIsValid] = useState(formAuditIsValid(getLatestAuditCEntry(props.patient)));
    const [smokeIsValid, setSmokeIsValid] = useState(formSmokeIsValid(props.patient?.smoking));
    const [oxygenIsValid, setOxygenIsValid] = useState(false);

    const [auditIsChanged, setAuditIsChanged] = useState(false);
    const [smokeIsChanged, setSmokeIsChanged] = useState(false);
    const [oxygenIsChanged, setOxygenIsChanged] = useState(false);

    const [pastMedicalHistoryId] = useState(() => uuidv4() + '');
    const [medicationsId] = useState(() => uuidv4() + '');
    const [socialHistoryId] = useState(() => uuidv4() + '');
    const [allergiesAndReactionsId] = useState(() => uuidv4() + '');

    const userObject = useSelector(user);
    const userFullName = Formatter.formatUserFullName(userObject);

    const formIsValid = () => {
        return auditIsValid && smokeIsValid;
    };

    useEffect(() => {
        if (props.onCustomButtons) {
            const buttons = [];

            if (activeStep > 0) {
                buttons.push(
                    <AgyleButton
                        colour="primary"
                        onClick={handlePrev}
                    >
                        {t('Prev')}
                    </AgyleButton>,
                );
            }
            buttons.push(
                <AgyleButton
                    colour="primary"
                    onClick={handleNext}
                >
                    {activeStep === steps.length - 1 ? 'Save Clerking' : 'Next'}
                </AgyleButton>,
            );
            props.onCustomButtons(buttons);
        }
        if (props.onHideSubmit) {
            props.onHideSubmit(true);
        }
    }, [activeStep]);

    const handleNext = () => {
        if (activeStep === steps.length - 1) {
            if (formIsValid()) {
                closeForm(false);
            } else {
                closeForm(true);
            }
        } else {
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
        }
    };

    const handlePrev = () => {
        if (activeStep > 0)
            setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const closeForm = (isDraft) => {
        let formTmp = {...form};
        formTmp.createDate = moment();
        formTmp.statusClosed = !isDraft;

        let valuesToChange = [
            {
                name: 'clerkingIP',
                value: formTmp,
                noteToAdd: Notes.getClerkingIPNote(formTmp),
            },
        ];
        if (oxygenIsChanged) {
            valuesToChange.push({
                name: 'oxygen',
                value: formOxygenData,
                noteToAdd: Notes.getOxygenNote(formOxygenData),
            });
        }

        if (auditIsChanged) {
            valuesToChange.push(buildAuditCListModification(formAuditCData, props.patient, userObject, userFullName, 'Clerking'));
        }

        if (smokeIsChanged) {
            valuesToChange.push({
                name: 'smoking',
                value: formSmokingData,
                noteToAdd: Notes.getSmokingNote(formSmokingData),
            });
        }

        if (delirium) valuesToChange.push(...delirium);

        props._customOnSave(valuesToChange);
        props.onClose();
    };

    useEffect(() => {
        if (props.patient?.clerkingIP) {
            setForm(_cloneDeep(props.patient.clerkingIP));
        } else {
            setForm({...formBase, by: userFullName});
        }
    }, [props.patient]);


    const onPropChange = (prop, eventValue, useValue) => {
        return (event, value) => {
            const data = {...form};
            if (eventValue) {
                _set(data, prop, event);
            } else {
                if (useValue) {
                    _set(data, prop, value);
                } else {
                    _set(data, prop, event.target.value);
                }
            }

            setForm(data);

        };
    };

    const handleFieldChange = (value, path) => {
        const data = {...form};
        _set(data, path, value);
        setForm(data);
    };

    const isStepFailed = (step) => {
        let failed = false;
        switch (step) {
            case 0:
                failed = (!form.chiefComplaint || !form.medications || !form.pastMedicalHistory || !form.socialHistory || !form.allergies);
                break;
            case 1:
                failed = Object.keys(form.examination).some((key) => !form.examination[key]);
                break;
            case 2:
                failed = !auditIsValid;
                break;
            case 3:
                failed = !smokeIsValid;
                break;
            case 4:
                let planFailed = Object.keys(form.plan).some((key) => !form.plan[key]);
                let oxyFailed = false;
                failed = (planFailed || oxyFailed);
                break;
            default:
                break;
        }
        return failed;
    };

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const lazyChangeFunction = (field, event) => {
        setForm((pr) =>
            ({
                ...pr,
                [field]: event.target.value,
                [field + 'Author']: pr.who + ' @ ' + moment().format('DD/MM/YYYY HH:mm:ss'),
            }),
        );
    };

    const renderHistoryStep = () => {
        return (
            <div>
                <Grid component="label" container alignItems="center" className={classes.containerGrid} gap={2}>
                    <Grid item xs={12}>
                        <div className={classes.inputLabel}>
                            {t('Chief Complaint')}
                        </div>

                        <ChiefOfComplaint
                            value={form.chiefComplaint}
                            onChange={value => {
                                const clone = _cloneDeep(form);
                                clone.chiefComplaint = value;
                                setForm(clone);
                            }}
                            admitDate={props.patient?.admission?.startDate}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CoreDataTextField
                            patient={props.patient.patient.__id}
                            path="core.patient.pastMedicalHistory"
                            instanceId={pastMedicalHistoryId}
                            label={t('Past Medical History')}
                            variant="outlined"
                            agyleRefresh
                            fullWidth
                            value={form.pastMedicalHistory}
                            onChange={e => lazyChangeFunction('pastMedicalHistory', e)}
                            showCoreValue
                            multiline
                            height={70}
                            hideHistory={props.pastAttendances}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <CoreDataTextField
                            patient={props.patient.patient.__id}
                            path="core.patient.medications"
                            instanceId={medicationsId}
                            label={t('Medications')}
                            variant="outlined"
                            agyleRefresh
                            fullWidth
                            value={form.medications}
                            onChange={e => lazyChangeFunction('medications', e)}
                            showCoreValue
                            multiline
                            height={70}
                            hideHistory={props.pastAttendances}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CoreDataTextField
                            patient={props.patient.patient.__id}
                            path="core.patient.allergies"
                            label={t('Allergies and reactions')}
                            instanceId={allergiesAndReactionsId}
                            variant="outlined"
                            value={form.allergies}
                            onChange={e => lazyChangeFunction('allergies', e)}
                            showCoreValue
                            multiline
                            agyleRefresh
                            fullWidth
                            height={70}
                            error={config?.allergiesMandatory && !form.allergies}
                            hideHistory={props.pastAttendances}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <CoreDataTextField
                            patient={props.patient.patient.__id}
                            path="core.patient.socialHistory"
                            instanceId={socialHistoryId}
                            label={t('Social History')}
                            variant="outlined"
                            value={form.socialHistory}
                            onChange={e => lazyChangeFunction('socialHistory', e)}
                            showCoreValue
                            multiline
                            agyleRefresh
                            fullWidth
                            height={70}
                            hidePreview
                            hideHistory={props.pastAttendances}
                            noBorder={false}
                            withNewBackground
                            size="large"
                        />
                    </Grid>
                </Grid>
            </div>
        );
    };

    const concatNotes = (pr, form) => {
        if (pr === null) return form;
        form[0].noteToAddWithRefId = form[0].noteToAddWithRefId.concat(
            pr[0].noteToAddWithRefId,
        );
        return form;
    };
    const setDeliriumForm = (form) => {
        setDelirium((pr) => {
            return concatNotes(pr, form);
        });
    };

    const [expanded, setExpanded] = React.useState({
        delirium: false,
    });

    const accordionChangeHandler = (accordion) => (ev) => {
        setExpanded((prev) => ({
            ...prev,
            [accordion]: !prev[accordion],
        }));
    };

    const renderExaminationStep = () => {
        return (
            <Grid component="label" alignItems="center" container spacing={2} className={classes.containerGrid}>
                <Grid item xs={12}>
                    <div className={classes.inputLabel}>
                        {t('Examinations')}
                    </div>

                    <AgyleTextField
                        debounce
                        fullWidth
                        multiline
                        minRows={5}
                        name="examination.examination"
                        value={form.examination.examination}
                        onChange={onPropChange('examination.examination')}
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={12}>
                    <AgyleAccordion
                        expanded={expanded.delirium}
                        onChange={accordionChangeHandler('delirium')}
                        label={t('4AT Assessment Test For Delirium & Cognitive Impairment')}
                        formBackground
                    >
                        <MultipleEntriesFormList
                            patient={props.patient}
                            type={'delirium'}
                            title={'4AT Screening for Delirium and Cognitive Impairment'}
                            field={'studies.delirium'}
                            showScore
                            scoreFiled={'totalScore'}
                            parentForm={'Clerking'}
                            clerking
                            override={delirium?.[0]?.value?.list}
                            onSave={setDeliriumForm}
                            disableSave={props.disableSave}
                            patientHaveModification={props.patientHaveModification}
                            modifyPatient={props.modifyPatient}
                            component={<Delirium patient={props.patient}/>}
                        />
                    </AgyleAccordion>
                </Grid>
            </Grid>
        );
    };

    const renderAuditCStep = () => {
        return (
            <Grid component="label" container alignItems="center" className={classes.containerGrid}>
                <Grid item xs={12}>
                    <AuditCForm
                        auditC={formAuditCData}
                        formIsValid={setAuditIsValid}
                        formIsChanged={setAuditIsChanged}
                        changeFormData={setAuditCFormData}
                    />
                </Grid>
            </Grid>
        );
    };

    const renderPlanStep = () => {
        return (
            <Grid component="label" alignItems="center" container spacing={2} className={classes.containerGrid}>
                <Grid item xs={12}>
                    <div className={classes.inputLabel}>
                        {t('Working diagnosis')}
                    </div>

                    <AgyleTextField
                        debounce
                        fullWidth
                        multiline
                        minRows={5}
                        name="plan.workingDiagnosis"
                        value={form.plan.workingDiagnosis}
                        onChange={onPropChange('plan.workingDiagnosis')}
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={12}>
                    <div className={classes.inputLabel}>
                        {t('Management plan')}
                    </div>

                    <AgyleTextField
                        debounce
                        fullWidth
                        multiline
                        minRows={5}
                        name="plan.managementPlan"
                        value={form.plan.managementPlan}
                        onChange={onPropChange('plan.managementPlan')}
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={12}>
                    <div className={classes.inputLabel}>
                        {t('Working diagnosis note (max 20 characters)')}
                    </div>

                    <AgyleTextField
                        debounce
                        fullWidth
                        maxLength={20}
                        name="plan.workingDiagnosisNote"
                        value={form.plan.workingDiagnosisNote}
                        onChange={onPropChange('plan.workingDiagnosisNote')}
                        noBorder={false}
                        withNewBackground
                        size="large"
                    />
                </Grid>

                <Grid item xs={4}>
                    {t('LMWH Prescribed')}
                </Grid>

                <Grid item xs={8}>
                    <AgyleBlockSwitch
                        onChange={(e) => handleFieldChange(e, 'plan.LMWHPrescribed')}
                        value={form.plan.LMWHPrescribed}
                        valueObject={{
                            false: 'No',
                            true: 'Yes',
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InformationBox type="info" label={'Oxygen Prescribing / Administration'}>
                        {props.patient?.oxygen &&
                            <div style={{marginBottom: 10}}>
                                {props.patient?.oxygen.hypercapnic && <div>
                                    This patient has <span style={{color: '#E25B61'}}> NOT BEEN DIAGNOSED </span> with
                                    Hypercapnic respiratory failure
                                </div>
                                }
                                {props.patient?.oxygen.noHypercapnic && <div>
                                    <div> This Patient <span style={{color: '#E25B61'}}> has confirmed Hypercapnic respiratory failure </span> on
                                        blood gas analysis on either a prior or their current hospital admission
                                    </div>
                                </div>
                                }
                                TARGET
                                SATURATION: {props.patient?.oxygen.lower} - {props.patient?.oxygen.upper} %
                            </div>
                        }

                        <AgyleButton
                            variant="contained"
                            onClick={() => dispatch(openPatientForm('oxygen'))}
                        >
                            {t(props.patient?.oxygen ? 'Update' : 'Add')}
                        </AgyleButton>
                    </InformationBox>
                </Grid>
            </Grid>
        );
    };

    const renderSmokeStep = () => {
        return (
            <Grid component="label" alignItems="center" container spacing={2} className={classes.containerGrid}>
                <Grid item xs={12}>
                    <SmokingForm
                        formData={formSmokingData}
                        formIsValid={setSmokeIsValid}
                        formIsChanged={setSmokeIsChanged}
                        changeFormData={setSmokingFormData}
                    />
                </Grid>
            </Grid>
        );
    };

    const renderStep = (step) => {
        // eslint-disable-next-line default-case
        switch (step) {
            case 0:
                return renderHistoryStep();
            case 1:
                return renderExaminationStep();
            case 2:
                return renderAuditCStep();
            case 3:
                return renderSmokeStep();
            case 4:
                return renderPlanStep();
        }
    };

    const renderStepper = () => {
        return (
            <div className={classes.modalHeader}>
                <AgyleStepper
                    steps={steps}
                    isStepFailed={isStepFailed}
                    activeStep={activeStep}
                    handleStep={handleStep}
                />
            </div>
        );
    };

    return (
        <div className={classes.formContainer}>
            {renderStepper()}

            <div className={classes.modalBody}>
                {renderStep(activeStep)}
            </div>
        </div>
    );
}

export default InlineClerkingForm;
